import React, { useState, useRef,useEffect } from 'react';
import { Wizard, NotificationList } from 'quanta-ui';
import Vehicle from './vehicle';
import Covers from './covers';
import {
  // faMotorcycle,
  faBus,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function QuoteWizardPanel({ 
  lobCode,
  productName,
  productCode,
  quoteNumber,
  lobName,
  productCode1,
  moveToPlans,
  setMoveToPlans,
  setProductCode,
  ...props
   }) {
  // const startStep = quoteNumber ? 1: 0;
  const [startStep, setStartStep] = useState(quoteNumber ? 1 : 0);
  useEffect(() => {
    if (moveToPlans) {
      setStartStep(1);
      setMoveToPlans(false);
    }
  }, [moveToPlans]);
  const [proceedToCoverPage, setproceedToCoverPage] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoadingStep] = useState(false);
  const vehicleFormRef = useRef();

  const steps = [
    {
      icon: <FontAwesomeIcon icon={faBus} />,
      label: 'Vehicle',
      proceedLabel: () => 'Get Covers',
      stepCompleted: () => proceedToCoverPage,
      submitForm: async () => {
        if (vehicleFormRef.current) {
          const res = await vehicleFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Warning',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  Please fill in all the mandatory fields to proceed
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      component: ({ expanded }) =>
        expanded ? 
           loading ? (
            <div className={'min-h-screen'}>
              <Loading />
            </div>
          ) : (
          <Vehicle
            productCode={productCode}
            productName={productName}
            lobCode={lobCode}
            lobName={lobName}
            quoteNumber={quoteNumber}
            setproceedToCoverPage={setproceedToCoverPage}
            forwardedRef={vehicleFormRef}
            setParentAlerts={setAlerts}
            productCode1={productCode1}
            setProductCode={setProductCode}
            modify={props?.modify} 
            setLoadingStep={setLoadingStep}
          />
        ) : null,
    },
    {
      icon: <FontAwesomeIcon icon={faFileAlt} />,
      label: 'Covers',
      proceedLabel: () => undefined,
      component: ({ expanded, goToStep }) =>
        expanded ? 
          loading ? (
            <div className={'min-h-screen'}>
              <Loading />
            </div>
          ) : (
          <Covers
            goToStep={goToStep}
            productCode={productCode}
            productName={productName}
            lobCode={lobCode}
            quoteNumber={quoteNumber}
            lobName={lobName}
            forwardedCoversFormRef={props?.forwardedCoversFormRef}
            modify={props?.modify} 
            setLoadingStep={setLoadingStep}
          />
        ) : null,
    },
  ];

  return (
    <div className="min-h-full">
      <Wizard
        {...{
          steps,
          startStep,
          tabStyle: true,
          switchTabs: false,
          buttonSize: 'medium',
        }}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </div>
  );
}
